<template>
    <section>
   <Cms
        model="content-section"
        driver="builder"
        :components="getBuilderComponents()"
        is-section
        :search-params="searchParams"
    />
    <div :class="{'plp': true, 'drawer-open' : showFilters}">
        <div class="filter-bar">
            <span class="filter-bar-count">{{ numberOfResults }} Results</span>
            <div class="filter-sort-buttons">
                <button class="filter-button" aria-label="Toggle filters" @click="toggleFilters()">
                    <span class="desktop-hidden">Sort & Filters </span>
                    <span class="mobile-hidden" id="toggleFiltersButton">{{ showFilters ? "Hide" : "Show" }} Filters </span>
                    <span class="applied-filters">({{ activeFilters ? activeFilters.length : 0 }})</span>
                </button>

                <ul v-if="sortOptions.length > 0" class="sort-content">
                    <li 
                        class="sort-select paragraph-default"
                        v-for="(option, index) in sortOptions"
                        :key="index"
                    ><a @click.prevent="setSortOption(option)" :aria-label="option.label">{{ 
                        option.label
                    }}</a></li>
                </ul>
            </div>
        </div>
        <div class="container-filter-product-grid">
            <ProductFilterDrawer v-model:active-filters="activeFilters" :facets="facets" :numResults="numberOfResults" v-model:show-drawer="showFilters"/>
            <!-- PRODUCT GRID START-->
            <div class="product-grid-container">
                <div class="product-grid blog-grid">
                    <ArticleCard v-for="(blogArticle, index) of data" :subject="blogArticle.category" :headline="blogArticle.name" :image="blogArticle.image" cta="View Article" :link="getBlogRoute(blogArticle)" :key="index"/>
                </div>
                <pagination
                    :pagination="searchSpringPagination"
                    @pageChange="handlePagination"
                />
            </div>
        </div>
    </div>
    </section>
</template>
<script lang="ts" setup>
    import { computed, ref } from "vue";
    // import { registeredComponents } from "../../blog-landing-init-builder";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import ArticleCard from "../components/ArticleCard.vue";
    import { useDebounceFn, watchDeep } from "@vueuse/core";
    import { useContent } from "@/helpers/composables/searchSpringApi";
    import ProductFilterDrawer from "@/components/ProductFilterDrawer.vue";
    import Pagination from "@/components/Pagination.vue";
    import { route } from "ziggy-js";

    let { data, searchSpringResults, handleFilter, handlePagination } = useContent({
        filters: [],
        sorts: [],
        searchTerm: "",
        bgFilter: {
            filter: 'bgfilter.ss_category_hierarchy',
            value: 'Blog'
        }
    });
    let activeFilters = ref([]);
    let facets = computed(()=>{
        return searchSpringResults.value?.facets.filter(facet => facet.field == 'ss_category_hierarchy').map(facet => ({
            ...facet,
            label: 'Type'
        })) || [];
    })
    let numberOfResults = computed(()=>{
        return searchSpringResults.value?.pagination?.totalResults;
    })

    const sortOptions = computed(()=>{
        return searchSpringResults.value.sorting.options ?? []
    })
    
    let getBlogRoute = ({url}) => {
        let lastPart = url.split("/").pop()
        return route('blog.show', { slug: lastPart });
        // return route('blog.show', { slug: route('blog.show', ) });
    }

    let showFilters = ref(false);
    let toggleFilters = () => {
        showFilters.value = !showFilters.value;
    }
    let handleFilterDebounce = useDebounceFn((newVal) => {
        handleFilter(newVal);
    }, 500);
    watchDeep(() => activeFilters.value, handleFilterDebounce);

    let sortOption = ref({})

    let setSortOption = (option) => {
        sortOption.value = option;
        handleSort(option);
    }

    let searchSpringPagination = computed(() => {
        // convert pagination data to match the pagination component
        return {
            totalItems: searchSpringResults.value.pagination.totalResults,
            currentPage: searchSpringResults.value.pagination.currentPage,
            pageSize: searchSpringResults.value.pagination.perPage,
            maxPages: searchSpringResults.value.pagination.totalPages
        };
    });

    let searchParams = computed(()=>({
        'data.pageUrl.$eq': '/blog'
    }))

</script>